// extracted by mini-css-extract-plugin
module.exports = {"privacyWrapper":"Privacy_privacyWrapper__3vs5L","privacyBody":"Privacy_privacyBody__2Khp6","privacyHTML":"Privacy_privacyHTML__1sm2D"};